'use client'

import styles from "./HeroSection.module.scss";
import Image from 'next/image';
import Text from '@components/atoms/Text';
import { useRouter } from 'next/navigation';
import assetLoader from '@utils/internalImageLoder';
import { closeWebView, updateAppBar } from "@hooks/useWebviewCallback";
import VideoModalWrapper from "@components/molecules/VideoModalWrapper";
import { useIsMobile } from "@hooks/use-mobile";
import { CARDROP_HEADER_APPBAR_CONFIG } from "@utils/appbarConfig";

const HeroSection = ({
  isInApp,
}: any) => {

  const router = useRouter();
  const isMobile = useIsMobile();

  updateAppBar(CARDROP_HEADER_APPBAR_CONFIG);

  const handleCloseContest = async () => {
    closeWebView(() => router.back());
  }

   const metaData = {
        authorName: "ACKO DRIVE",
        authorType: "ACKO DRIVE",
        duration: "127",
        mediaSource: "S3",
        primaryText: "ACKO Drive Car Drop Winner",
        secondaryText: "",
        thumbnail: isMobile ? `${assetLoader()}/images/CarDrop/jan_car_drop_winner_vertical_thumbnail.webp` : `${assetLoader()}/images/CarDrop/jan_car_drop_winner_horizontal_thumbnail.webp`,
        title: "ACKO Drive Car Drop Winner",
    };

    const videoUrl = "https://ackodrive-prod.ackoassets.com/video/generic/jancar_drop_winner_vertical.m3u8";
    const desktopVideoUrl = "https://ackodrive-prod.ackoassets.com/video/generic/jan_car_drop_winner_horizontal.m3u8";

  return (
    <>
      <div className={styles.carDropWinnerContainer}>
        <div
          className={styles.carDropContainerHeader}
        >
          {
            !isInApp &&
              <Image
                src={`${assetLoader()}/icons/Chevron_left_light.svg`}
                alt='arrow icon'
                width={24}
                height={24}
                loading='eager'
                className={styles.carDropBackIcon}
                onClick={handleCloseContest}
              />
          }
          <Image
            src={`${assetLoader()}/images/CarDropLogo.svg`}
            alt='arrow icon'
            fill
            loading='eager'
            className={styles.carDropLogo}
          />
        </div>
        <div className={styles.CWDwinnerUserSection}>
              <Text className={styles.CWDwinnerUserSectionHeading}>Meet our January Car Drop Winner</Text>
              <div className={styles.CWDwinnerUserSectionContent}>
                <VideoModalWrapper
                    metaData={metaData}
                    videoUrl={videoUrl}
                    desktopVideoUrl={desktopVideoUrl}
                >
                    <Image 
                        src={`${assetLoader()}/images/CarDrop/winnerPersonThumbnail_January.webp`}
                        alt='Winner Thumbnail'
                        fill
                        className={styles.CWDwinnerSectionUserImage}
                    />
                </VideoModalWrapper>
              </div>
              <Text className={styles.CWDwinnerSectionUserName}>Martin P David</Text>
              <Text className={styles.CWDwinnerSectionUserCity}>Bengaluru, Karnataka</Text>
              <Image 
                  src={`${assetLoader()}/images/CarDrop/ACR_CarName_Jan.webp`}
                  alt='Winner Thumbnail'
                  fill
                  className={styles.CWDwinnerSectionCarImage}
              />
              <Text className={styles.CWDwinnerSectionDescp}>“I honestly thought this was a prank. Turns out I really won an MG Hector! Thank you ACKO Drive for this unbelievable surprise that I&apos;ll never forget.”</Text>
            </div>
      </div>
    </>
  )
}

export default HeroSection;
